import { ProductBySlugNonNullable } from "@/common/contracts/pdp.contracts";
import useProductUtils from "@/hooks/useProductUtils";
import { Body } from "@/ui/typography/Body";

type ProductDetailsInfoSellerLocationProps = {
  product: ProductBySlugNonNullable;
};

export const ProductDetailsInfoSellerLocation = ({
  product,
}: ProductDetailsInfoSellerLocationProps) => {
  const { getLocation, getLocationFlagComponent } = useProductUtils();

  const LocationFlag = getLocationFlagComponent(product);
  const address = getLocation(product);

  return (
    <Body className="flex items-center text-sm">
      {LocationFlag && <LocationFlag />}
      <span className="ml-1">{address}</span>
    </Body>
  );
};
